/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ui/NG_FACEBOOK': {
    width: 16,
    height: 16,
    viewBox: '0 0 8 18',
    data: '<path pid="0" d="M1.82 5.89H0V9h1.82v9h3.49V8.92h2.43l.26-3H5.31V4.15c0-.71.13-1 .8-1H8V0H5.58C3 0 1.82 1.19 1.82 3.46z" _fill="#545454" fill-rule="evenodd"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/app-icons/ui/NG_FACEBOOK.js